import { takeEvery } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import { reset as resetForm } from 'redux-form';

import { resetFields, RESET_CREATE_AD, AD_CREATED } from 'actions/editable-ad';
import { logUserAction } from 'actions/analytics';
import { CAMPAIGN_FORM_NAME, AUDIENCE_FORM_NAME } from 'config';
import { getRateCardId, getPriceData } from 'selectors/audienceSizer';

import debug from 'debug';
const log = debug('sagas:adCreation');

export function* handleResetCreateAd() {
  yield put(resetFields());
  yield put(resetForm(CAMPAIGN_FORM_NAME));
  yield put(resetForm(AUDIENCE_FORM_NAME));
}

export function* watchForResetCreateAd() {
  yield call(takeEvery, RESET_CREATE_AD, handleResetCreateAd);
}

export function* handleAdCreated() {
  log('detected that an ad was created');

  const rateCardId = yield select(getRateCardId);

  if (rateCardId) {
    const priceData = yield select(getPriceData);

    yield put(logUserAction({
      category: 'create_ad_flow',
      label: 'rate_card_for_user',
      params: {
        id: rateCardId,
        ...priceData,
      },
    }));
  } else {
    log('no rate card found for the ad');
  }
}

export function* watchAdCreated() {
  yield call(takeEvery, AD_CREATED, handleAdCreated);
}



// WEBPACK FOOTER //
// ./src/middleware/sagas/adCreation.js